module.exports = __webpack_public_path__ + "static/media/member-img-1.ec4e405f.png";